import React from 'react';
import { Icon } from '@phosphor-icons/react';
import classNames from 'classnames';

import { Button, ButtonLink } from '../../../../components/general';
import { HoverIcon } from '../../../icons';

interface Props {
  id: string;
  Icon: Icon;
  url?: string;
  onClick?: () => void;
  label?: string;
  isFull?: boolean;
  isCurrent?: boolean;
}

const SideNavMainBtn: React.FC<Props> = (props) => {
  const { id, Icon, url, onClick, label, isFull, isCurrent } = props;

  const iconElement = isFull ? (
    <HoverIcon
      Icon={Icon}
      weight="light"
      size="2.47rem"
      className="text-primary-900"
    />
  ) : (
    <div
      className={classNames(
        'w-8 aspect-square flex items-center justify-center p-1 text-xl leading-none rounded-md group-hover:bg-white group-hover:shadow-md',
        { 'bg-white shadow-md': isCurrent },
      )}
    >
      <Icon weight={isCurrent ? 'fill' : 'regular'} />
    </div>
  );

  const content = (
    <React.Fragment>
      {iconElement}
      {label && <div className="text-xs font-medium leading-none">{label}</div>}
    </React.Fragment>
  );

  const buttonProps = {
    id: `project-sidenav-tab-${id}`,
    'aria-controls': `project-sidenav-tabpanel-${id}`,
    onClick,
    variant: 'custom' as const,
    colour: 'custom' as const,
    className:
      'group w-14 flex flex-col items-center justify-center gap-1.5 text-black text-center',
  };

  if (url)
    return (
      <ButtonLink {...buttonProps} to={url}>
        {content}
      </ButtonLink>
    );

  return <Button {...buttonProps}>{content}</Button>;
};

export default SideNavMainBtn;
